import { useMemo } from 'react';

import { useStores } from 'mobx/hooks/useStores';

import Patient from 'models/Patient';

export const useLocationOptions = (patient?: Patient) => {
  const { locationsStore } = useStores();

  return useMemo(() => {
    let options = locationsStore.locationsForSelect;

    // If patient has a location and it's not already in visible options, add it
    if (patient?.location) {
      const isPatientLocationIncluded = options.some(
        (option) => option.value?.id === patient.location.id
      );

      if (!isPatientLocationIncluded) {
        const patientLocation = locationsStore.getLocationById(patient.location.id);
        if (patientLocation) {
          options = [
            ...options,
            {
              value: patientLocation,
              label: `${patientLocation.name} (Inactive)`
            }
          ];
        }
      }
    }

    return options;
  }, [locationsStore, patient?.location]);
};
